// Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { pick } from 'lodash'

import {
  Report,
  ReportHeader,
  ReportSection
} from '../'

import {
  applyRenderTemplate
} from '../../utils'

export default class MetricsReportKPI extends React.Component {
  static propTypes = {
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: ''
  }

  render() {
    let { createdAt, data, className } = this.props

    return (
      <div className={className}>
        <Report
          header={
            <ReportHeader
              heading='Key performance indicators'
              valuesAtDate={moment(createdAt).format('DD MMMM YYYY')}
            />
          }
          content={[
            <KPIMetrics metrics={data} key='report_kpi_metrics' />
          ]}
        />
      </div>
    )
  }
}

const KPIMetrics = ({ metrics }) => {
  const dataToRender = applyRenderTemplate(
    metrics,
    {
      "Clients": "NumberField",
      "Active Clients": "NumberField",
      "EarnBacks Only": "NumberField",
      "Active - Credit": "NumberField",
      "Active Employees": "NumberField",
      "EarnBacks Members": "NumberField",
      "Active - Insurance": "NumberField",
      "Active Non-members": "NumberField",
      "Eligible Employees": "NumberField",
      "Active - Investments": "NumberField",
      "EarnBacks Members - Outstanding": "NumberField"
    }
  )

  if (dataToRender !== null) {
    return (
      <React.Fragment>
        <ReportSection
          data={pick(dataToRender, ['Active Employees', 'Clients', 'Active Clients', 'Active Non-members'])}
          className='slds-p-bottom_medium'
          key='reportSection_one'
        />
        <ReportSection
          data={pick(dataToRender, ['EarnBacks Members', 'EarnBacks Members - Outstanding'])}
          className='slds-p-bottom_medium'
          leftAlign={true}
          key='reportSection_two'
        />
        <ReportSection
          data={pick(dataToRender, ['Active - Investments', 'Active - Insurance', 'Active - Credit', 'EarnBacks Only'])}
          className='slds-p-bottom_medium'
          key='reportSection_three'
        />
      </React.Fragment>
    )
  } else {
    return null
  }
}

KPIMetrics.propTypes = {
  metrics: PropTypes.arrayOf(PropTypes.object).isRequired
}



// WEBPACK FOOTER //
// ./src/components/metrics-report-kpi/index.js